import React, { useState, useRef } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Container = styled.div`
  position: relative;
`

const Input = styled.input`
  border: solid #C5C5C5 1px;
  padding: 10px 20px 10px 20px;
  width: 100%;
  font-size: 1em;
  border-radius: 0px;
  outline: none;
  box-sizing: border-box;
`

const Results = styled.section`
  position: absolute;
  z-index: 9999;
  top: 39px;
  width: 100%;
  background: #FFF;
  box-sizing: border-box;
`

const WrapperItem = styled.span`
  padding: 15px;
  font-size: 1em;
  border: solid #C5C5C5 1px;
  margin-bottom: -1px;
  cursor: pointer;
  display: block;
  color: #4D4D4D;
  text-decoration: none;
  width: 100%;
  box-sizing: border-box;
  font-family: sans-serif;

  &:hover{
    color: #265BFF;
    background-color: #FBFBFB;
    text-decoration: undeline;
  }
`

const WrapperItemSelected = styled(WrapperItem)`
  color: #265BFF;
  font-weight: bold;
  background-color: #F0F0F0;
  text-decoration: undeline;
`

function Item(item) {
  return (
    <WrapperItem
      className="cn-searchbox__item"
    >
      {item.name}
    </WrapperItem>
  )
}

function ItemSelected(item) {
  return (
    <WrapperItemSelected
      className="cn-searchbox__item-selected"
    >
      {item.name}
    </WrapperItemSelected>
  )
}

function ID() {
  return "_" + Math.random().toString(36).substr(2, 9)
}

export function Searchbox({
  data,
  limit,
  searchKey,
  placeholder,
  onComplete
}) {
  const INVALID_INDEX = -1

  const [text, setText] = useState("")
  const [searchResult, setSearchResult] = useState([])
  const [selectedItem, setSelectedItem] = useState(INVALID_INDEX)
  const wrapper = useRef(null)
  const input = useRef(null)

  function searching(value) {
    setSelectedItem(INVALID_INDEX)

    const filtered = data.filter(item => {
      const current = item[searchKey].toLowerCase()
      const key = value.toLowerCase()

      if (current.startsWith(key)) {
        return item
      }
    })

    setSearchResult(filtered.slice(0, limit))

    if (!value) {
      setSearchResult([])
    }
  }

  function hiddenWrapper() {
    if (wrapper.current) {
      wrapper.current.style.display = "none"
    }
  }

  function showWrapper() {
    if (wrapper.current) {
      wrapper.current.style.display = "block"
    }
  }

  function onChangeHandle(event) {
    const { value } = event.target
    setText(value)
    searching(value)
  }

  /* istanbul ignore next */
  function onBlurHandle() {
    document.addEventListener("click", () => {
      hiddenWrapper()
    })

    if (input.current) {
      input.current.addEventListener("click", event => {
        event.stopPropagation()
      })
    }
  }

  /* istanbul ignore next */
  function onFocusHandle(event) {
    const { value } = event.target
    showWrapper()
    searching(value)
  }

  function itemClickedHandle(item) {
    return () => {
      setText(item[searchKey])
      hiddenWrapper()
      onComplete(item)
    }
  }

  function onMoveHandle(e) {
    if (e.key === "ArrowDown" && selectedItem < searchResult.length - 1) {
      showWrapper()
      setSelectedItem(selectedItem + 1)
      setText(searchResult[selectedItem + 1][searchKey])
    }

    if (e.key === "ArrowUp" && selectedItem > 0) {
      showWrapper()
      setSelectedItem(selectedItem - 1)
      setText(searchResult[selectedItem - 1][searchKey])
    }

    if (e.key === "Enter" && searchResult.length > 0) {
      hiddenWrapper()
      onComplete(searchResult[selectedItem])
    }
  }

  return (
    <Container
      className="cn-searchbox__container"
      id="cn-searchbox-container"
    >

      <Input
        className="cn-searchbox__input"
        autoComplete="off"
        ref={input}
        id="cn-searchbox-input"
        type="text"
        placeholder={placeholder}
        value={text}
        onBlur={onBlurHandle}
        onKeyDown={onMoveHandle}
        onFocus={onFocusHandle}
        onChange={onChangeHandle}
      />

      {
        Boolean(searchResult.length) &&
          <Results
            className="cn-searchbox__results"
            id="cn-searchbox-results"
            ref={wrapper}
          >
            {
              searchResult.map((item, index) => {
                return (
                  <div onClick={itemClickedHandle(item)} key={ID()}>
                    {
                      selectedItem === index
                        ? ItemSelected(item)
                        : Item(item)
                    }
                  </div>
                )
              })
            }
          </Results>
      }

    </Container>
  )
}

Searchbox.propTypes = {
  onComplete: PropTypes.func,
  placeholder: PropTypes.string,
  data: PropTypes.array,
  limit: PropTypes.number,
  searchKey: PropTypes.string
}

Searchbox.defaultProps = {
  placeholder: "Search",
  limit: 10,
  data: {}
}
